var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8805_9176)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8805_9176",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 65,
    height: 65
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.332031 0.3335H64.332V64.3335H0.332031V0.3335Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8805_9176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.832 26.5835C61.832 13.4666 51.1988 2.8335 38.082 2.8335C24.9652 2.8335 14.332 13.4666 14.332 26.5835C14.332 39.7004 24.9652 50.3335 38.082 50.3335",
    stroke: "#7F8591",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.332 26.5835C14.332 39.7004 24.9653 50.3335 38.082 50.3335C51.1989 50.3335 61.832 39.7004 61.832 26.5835C61.832 13.4666 51.1989 2.8335 38.082 2.83349",
    stroke: "#7F8591",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.207 43.5835L2.83203 61.8335",
    stroke: "#7F8591",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.582 34.0835L45.582 19.0835",
    stroke: "#7F8591",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.582 19.0835L45.582 34.0835",
    stroke: "#7F8591",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8805_9176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.332031 0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIcon);
export default __webpack_public_path__ + "static/media/ZoomIcon.55d17755ac88ba1fb8b004efe22f7d4a.svg";
export { ForwardRef as ReactComponent };